import { createAction } from '@ngrx/store';

/**
 * Action to clear whole app state
 */
export const clearAppStateAction = createAction('APP_STATE:CLEAR_STATE');
